import {
	Autocomplete,
	Box,
	IconButton,
	TextField,
	Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import deleteIcon from "../../../../../../../../assets/images/trash-icons/trash-011.svg";
import { node_server } from "../../../../../../../../constants";
import { useTheme } from "../../../../../../../../context/themeContext";
import { setRoles } from "../../../../../../../../store/slices/profile/rolesSlice";
import styles from "./style.module.css";

const RoleShow = ({ role, num }) => {
	const { theme } = useTheme();
	const [selectedCategory, setSelectedCategory] = useState(role.category);
	const [selectedSkill, setSelectedSkill] = useState(role.creator_skill);
	const [selectedSpecialty, setSelectedSpecialty] = useState(role.speciality);
	const [categories, setCategories] = useState([]);
	const [skills, setSkills] = useState([]);
	const [specialities, setSpecialities] = useState([]);
	const dispatch = useDispatch();
	const roles = useSelector((state) => state.roles.value);
	console.log({ role, roles });
	useEffect(() => {
		setSelectedCategory(role.category);
		setSelectedSkill(role.creator_skill);
		setSelectedSpecialty(role.speciality);
	}, [role]);

	const handleDeleteClick = async (role) => {
		const filteredRoles = await roles.filter((item) => {
			return item.num !== role.num;
		});
		const updatedRoles = filteredRoles.sort((a, b) =>
			a.num > b.num ? 1 : -1,
		);
		dispatch(setRoles(updatedRoles));
	};

	const updateRoles = () => {
		const updatedRole = {
			num: role.num,
			selectedCategory,
			selectedSkill,
			selectedSpecialty,
		};

		const newRoles = roles.map((item) => {
			if (item.num === role.num) {
				return updatedRole;
			}
			return item;
		});

		dispatch(setRoles(newRoles));
	};

	useEffect(() => {
		updateRoles();
	}, [selectedCategory, selectedSkill, selectedSpecialty]);

	useEffect(() => {
		const fetchCategories = async () => {
			const { data, error } = await axios.get(
				`${node_server}/api/creator-types/categories`,
				{ withCredentials: true },
			);

			if (error) console.log(error);
			setCategories(data);
		};

		fetchCategories();
	}, []);

	useEffect(() => {
		if (!selectedCategory) return;
		const fetchSkills = async () => {
			const { data, error } = await axios.post(
				`${node_server}/api/skills/names`,
				{
					category: selectedCategory.category,
				},
				{ withCredentials: true },
			);
			if (error) console.log(error);
			setSkills(data);
		};

		fetchSkills();
	}, [selectedCategory]);

	useEffect(() => {
		if (!selectedSkill) return;
		const fetchSpecialities = async () => {
			const { data, error } = await axios.post(
				`${node_server}/api/skills/specialities`,
				{
					skillName: selectedSkill.skill,
				},
				{ withCredentials: true },
			);
			if (error) console.log(error);
			setSpecialities(data);
		};

		fetchSpecialities();
	}, [selectedSkill]);

	return (
		<React.Fragment>
			<Box className={styles.content}>
				<Typography
					variant="body1"
					sx={{
						color: theme.palette.darkgrey.darkgrey600,
						fontWeight: "500",
					}}
				>
					Role #{num}
				</Typography>
				{roles.length > 1 && (
					<IconButton onClick={() => handleDeleteClick(role)}>
						<img
							src={deleteIcon}
							alt="delete"
							style={{ fill: theme.palette.darkgrey.darkgrey300 }}
						/>
					</IconButton>
				)}
			</Box>
			<Box className={styles.inputField}>
				<Autocomplete
					sx={{ bgcolor: theme.palette.lightgrey.lightgrey00 }}
					options={categories ? categories : []}
					getOptionLabel={(option) => option.category}
					value={selectedCategory}
					onChange={(event, newValue) =>
						setSelectedCategory(newValue)
					}
					fullWidth
					renderInput={(params) => (
						<TextField
							{...params}
							label="Select Category"
							variant="outlined"
						/>
					)}
				/>

				<Autocomplete
					sx={{ bgcolor: theme.palette.lightgrey.lightgrey00 }}
					options={skills ? skills : []}
					getOptionLabel={(option) => option.skill}
					onChange={(event, newValue) => setSelectedSkill(newValue)}
					value={selectedSkill}
					fullWidth
					renderInput={(params) => (
						<TextField
							{...params}
							label="Select Skill"
							variant="outlined"
						/>
					)}
				/>

				<Autocomplete
					sx={{ bgcolor: theme.palette.lightgrey.lightgrey00 }}
					options={specialities ? specialities : []}
					getOptionLabel={(option) => option.speciality}
					value={selectedSpecialty}
					onChange={(event, newValue) =>
						setSelectedSpecialty(newValue)
					}
					fullWidth
					renderInput={(params) => (
						<TextField
							{...params}
							label="Select Specialty"
							variant="outlined"
						/>
					)}
				/>
			</Box>
		</React.Fragment>
	);
};

export default RoleShow;
